export default __webpack_public_path__ + "static/media/blog-post-layout-02-img-01.7bb841a7.jpg";